<template>
    <p
        v-if="error"
        class="text-[10px] mt-1"
        :class="error ? 'text-red-600' : 'text-gray-800'"
        id="email-error"
    >
        {{ error }}
    </p>
    <p class="mb-2.5 text-sm">{{ label }}</p>
    <div
        v-for="(option, index) in options"
        :key="index"
        class="flex items-center mb-2.5 last:mb-0"
    >
        <input
            :id="`${keyID}-${option.id}`"
            :name="name"
            type="radio"
            class="
                cursor-pointer
                h-4
                w-4
                text-black
                border-gray-300
                focus:ring-0
                focus:ring-offset-0	
                focus:outline-0
                focus:outline-offset-0	
                checked:border-black
            "
            @change="$emit('update:modelValue', option.value)"
            :checked="modelValue === option.value"
        />
        <label
            :for="option.id"
            class="ml-3 block text-sm"
            :class="modelValue === option.value ? 'text-primary-600' : 'text-black'"
        >
            {{ option.label }}
        </label>

    </div>
</template>

<script setup lang="ts">
defineProps({
    modelValue: {
        default: null,
        required: true,
    },
    options: {
        type: Array,
    },
    name: {
        type: String,
    },
    label: {
        type: String,
    },
    keyID: {
        type: String,
        default: 'key',
    },
    error: {
        type: String,
        default: null,
    },
});
</script>